import { Pipe, PipeTransform, EventEmitter } from '@angular/core';

@Pipe({
  name: 'hasObservers',
})
export class HasObserversPipe implements PipeTransform {
  transform(output: EventEmitter<any>): boolean {
    return output && output.observers.length > 0;
  }
}
